// IT & Digitalization team members shown in the support / team section.
// Extracted verbatim from the deployed build. Admin-editable via the "team" setting.

import { putSetting, getPublic } from "../lib/api";

export interface TeamMember {
  id: string;
  photo: string;
  ext: string;
  email: string;
  nameAr: string;
  nameEn: string;
  titleAr: string;
  titleEn: string;
  descAr: string;
  descEn: string;
}

export const team: TeamMember[] = [
  {
    id: "itdm",
    photo: "/team/ITDM.webp",
    ext: "346",
    email: "aalhunaydi@kaden-sa.com",
    nameAr: "عبدالله الهنيدي",
    nameEn: "Abdullah Al-Hunaidi",
    titleAr: "مدير تقنية المعلومات والرقمنة",
    titleEn: "IT & Digitalization Manager",
    descAr: "يقود رؤية الرقمنة في كادن بعين استراتيجية تُحوّل التقنية من أداة إلى ميزة تنافسية حقيقية. همّه الأول: أن تكون تجربتك الرقمية سلسة من يومك الأول.",
    descEn: "Drives Kaden's digitalization vision with a strategic lens, turning technology into a true competitive advantage. His priority: making your digital experience seamless from day one.",
  },
  {
    id: "itds",
    photo: "/team/ITDS.webp",
    ext: "345",
    email: "anabil@kaden-sa.com",
    nameAr: "عبد الرحمن نبيل",
    nameEn: "AbdulRahman Nabil",
    titleAr: "مشرف تقنية المعلومات والرقمنة",
    titleEn: "IT & Digitalization Supervisor",
    descAr: "الرجل الذي يُحوّل الأفكار إلى حلول. يُشرف على تنفيذ المشاريع التقنية اليومية ويضمن أن كل نظام يعمل بكفاءة. تجد له دائماً وقتاً وحلاً لأي مشكلة.",
    descEn: "The man who turns ideas into solutions. He oversees day-to-day tech projects and makes sure every system runs at its best. Always ready with time and a fix for any issue.",
  },
  {
    id: "its",
    photo: "/team/ITS.png",
    ext: "206",
    email: "kalshehri@kaden-sa.com",
    nameAr: "خلود الشهري",
    nameEn: "Khulood Al-Shahri",
    titleAr: "أخصائية تقنية المعلومات",
    titleEn: "IT Specialist",
    descAr: "نقطة الاتصال الأولى لكل ما يتعلق بالأجهزة والبرامج والحسابات. تتميّز بسرعة الاستجابة وصبر لا ينتهي في شرح كل تفاصيل التقنية بوضوح وبساطة.",
    descEn: "Your go-to person for all things hardware, software, and accounts. Known for her quick response time and endless patience in explaining every tech detail clearly and simply.",
  },
  {
    id: "itns",
    photo: "/team/ITNS.png",
    ext: "315",
    email: "faljuhaimi@kaden-sa.com",
    nameAr: "فهد الجهيمي",
    nameEn: "Fahad Al-Juhaimi",
    titleAr: "أخصائي شبكات",
    titleEn: "IT Network Specialist",
    descAr: "يعمل في الخفاء ليبقى الإنترنت في ضوء دائم. مسؤول عن البنية التحتية للشبكة وأمنها. إذا كان الاتصال يعمل بسلاسة، فاعلم أن فهد يفعل ما يُتقنه.",
    descEn: "Works behind the scenes to keep your connectivity in the spotlight. Responsible for network infrastructure and security. If your internet just works, Fahad's doing what he does best.",
  },
];

// --- Admin-editable team store (settings key "team") ---
const TEAM_CHANGED = "kd-team-changed";
let current: TeamMember[] = [...team];

export function getTeam(): TeamMember[] {
  return current;
}
export function subscribeTeam(cb: () => void): () => void {
  window.addEventListener(TEAM_CHANGED, cb);
  return () => window.removeEventListener(TEAM_CHANGED, cb);
}
function emit() {
  try {
    window.dispatchEvent(new Event(TEAM_CHANGED));
  } catch {
    /* ignore */
  }
}
export async function loadTeam(): Promise<void> {
  // Public, unauthenticated read — "it_team" is on the public settings allowlist
  // so every employee session (not just logged-in admins) picks up admin edits.
  const res = await getPublic<TeamMember[]>("it_team");
  const value = Array.isArray((res.data as any)?.value) ? (res.data as any).value : res.data;
  if (Array.isArray(value) && value.length > 0) current = value as TeamMember[];
  emit();
}
export async function saveTeam(members: TeamMember[]): Promise<{ ok: boolean; error?: string }> {
  current = members;
  emit();
  const res = await putSetting("it_team", members);
  return res.ok ? { ok: true } : { ok: false, error: res.error };
}
export async function resetTeam(): Promise<{ ok: boolean; error?: string }> {
  return saveTeam([...team]);
}
export function newTeamMember(): TeamMember {
  return { id: "m-" + Math.random().toString(36).slice(2, 7), photo: "", ext: "", email: "", nameAr: "", nameEn: "", titleAr: "", titleEn: "", descAr: "", descEn: "" };
}
